module.exports = __webpack_public_path__ + "static/media/abeed.0726369b.jpg";